/*
 * External checkout of the Checkout buttons of the cart drawer and of the cart page (Theme settings > External
 * checkout, on by default; off, this file is not loaded).
 *
 * The checkout partner's script, added to layout/theme.liquid, sends the customer to
 * https://checkout.<domain>/checkout/<btoa(JSON.stringify({ shopUrl, cartToken }))>. It hooks the Checkout buttons that
 * are in the page when it runs and marks each one data-tri="true"; a button rendered later (cart drawer filled after an
 * add to cart, cart lines updated) is hooked only once its observer has run, up to a second later, and a click in
 * between would go to the Shopify checkout. This file makes the same redirect for a Checkout button of the cart form
 * (button name="checkout" form="cart-form") that the script has not hooked; a hooked button is left to the script. It
 * never handles an add to cart.
 *
 * Back from the checkout, a page restored from the back-forward cache keeps the state of the partner's script, whose
 * flag isLoaded then ignores every new click on its buttons; it is reset on that restore.
 */
(() => {
  if (window.__externalCheckout) return;
  window.__externalCheckout = true;

  const CHECKOUT_BUTTON = 'button[name="checkout"][form="cart-form"]';
  const HOOKED = 'data-tri';
  let pending = false;

  /** Same value as the partner's script: the cart cookie, without what follows « ? ». */
  const clean = (value) => String(value).split('?')[0].split('%3F')[0];

  const cookieToken = () => {
    const match = document.cookie.match(/(?:^|; )cart=([^;]*)/);
    return match ? clean(decodeURIComponent(match[1])) : '';
  };

  const redirect = (cartToken) => {
    const shopUrl = window.Shopify && window.Shopify.shop ? window.Shopify.shop : '';
    const token = btoa(JSON.stringify({ shopUrl, cartToken }));
    window.location.href = 'https://checkout.' + window.location.host + '/checkout/' + token;
  };

  document.addEventListener(
    'click',
    (event) => {
      if (event.defaultPrevented || !(event.target instanceof Element)) return;
      const button = event.target.closest(CHECKOUT_BUTTON);
      if (!button || button.disabled || button.getAttribute(HOOKED) === 'true') return;
      // The partner's script already started its redirect for this click (its mousedown or touchstart came first, on a
      // button whose data-tri a new render of the cart removed): no second redirect.
      // eslint-disable-next-line no-undef
      if (typeof isLoaded !== 'undefined' && isLoaded === true) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      const cartToken = cookieToken();
      if (cartToken) {
        redirect(cartToken);
        return;
      }
      if (pending) return;
      pending = true;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then((response) => response.json())
        .then((cart) => redirect(clean(cart.token)))
        .catch(() => {})
        .finally(() => {
          pending = false;
        });
    },
    { capture: true }
  );

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    // Global « let » of the partner's script, when it is in the page.
    // eslint-disable-next-line no-undef
    if (typeof isLoaded !== 'undefined' && isLoaded === true) isLoaded = false;
  });
})();
